<template>
  <div>
    <div class="form_box">
      <el-form :model="forms" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
        :label-position="'left'">
        <div class="form_top">
          <div class="form_top_right">
            <el-form-item label="主题" prop="meetingtTitle">
              <!-- <el-input class="inputWith" v-model="forms.meetingtTitle"></el-input> -->
              <el-autocomplete class="inputWith" v-model="forms.meetingtTitle" :fetch-suggestions="querySearch"
                placeholder="请输入会议主题" @select="handleSelect">
                <template slot-scope="{ item }">
                  <div style="display: flex;justify-content: space-between; align-items: center;">
                    <div>{{ item }}</div>
                    <div @click.stop="onClear(item)"><i class="el-icon-circle-close"></i></div>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="会议室" prop="meetingLocationId">
              <el-select class="inputWith" v-model="forms.meetingLocationId" placeholder="请选择" clearable>
                <el-option class="inputWith" v-for="item in this.meetingLocationList" :key="item.value"
                  :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="meetingStateTime">
              <formDate v-model="forms.meetingStateTime" type="datetime" format="yyyy-MM-dd HH:mm"
                :timePickerOptions="timePickerOptionsItem"></formDate>
            </el-form-item>
            <el-form-item label="会议时长" prop="meetingDuration">
              <el-select class="inputWith" v-model="forms.meetingDuration" placeholder="请选择" @change="this.handleChange"
                clearable>
                <el-option class="inputWith" v-for="item in this.durationOption" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会议组" prop="className">
              <el-select v-model="forms.className" class="inputWith" filterable @change="this.onCouponAlis" multiple
                placeholder="请选择">
                <el-option class="inputWith" v-for="item in this.classList" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="邀请人" prop="userIds">
              <el-select class="inputWith" v-model="forms.userIds" filterable remote reserve-keyword
                :remote-method="searchKeyword" multiple placeholder="请选择">
                <el-option class="inputWith" v-for="item in this.userList" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会议提醒" prop="meetingReminder">
              <el-select class="inputWith" v-model="forms.meetingReminder" placeholder="请选择"
                @change="this.handleChange2" clearable>
                <el-option class="inputWith" v-for="item in this.reminderOption" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="签到时间" prop="meetingCheckDuration">
              <el-select class="inputWith" v-model="forms.meetingCheckDuration" placeholder="请选择"
                @change="this.handleChange3" clearable>
                <el-option class="inputWith" v-for="item in this.checkDurationOption" :key="item.value"
                  :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input class="inputWith" v-model="forms.remark"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form_btn">
          <el-form-item>
            <el-button type="primary" @click="handleSubmit()">保存
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>

import dayjs from "dayjs";

let pinyin = require('js-pinyin');

export default {

  data() {
    return {
      mname: "commondescr",
      key: "id",
      url: {},
      id: "",
      typeId: "",
      rules: {
        // meetingtTitle: [{ required: true, message: "请输入主题", trigger: "blur" }],
        meetingLocationId: [{ required: true, message: "请选择会议室", trigger: "blur" }],
        meetingStateTime: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
      },
      timePickerOptionsItem: { steps: [1, 15], },
      durationOption: [
        {
          value: 1,
          name: "30分钟",
        },
        {
          value: 2,
          name: "1小时",
        },
        {
          value: 3,
          name: "1.5小时",
        },
        {
          value: 4,
          name: "2小时",
        },
        {
          value: 5,
          name: "2.5小时",
        },
        {
          value: 6,
          name: "3小时",
        },
        {
          value: 7,
          name: "3.5小时",
        },
        {
          value: 8,
          name: "4小时",
        },
        {
          value: 9,
          name: "4.5小时",
        },
        {
          value: 10,
          name: "5小时",
        },
        {
          value: 11,
          name: "5.5小时",
        },
        {
          value: 12,
          name: "6小时",
        },
        {
          value: 13,
          name: "6.5小时",
        },
      ],
      classList: [],
      meetingLocationList: [],
      userList: [],
      reminderOption: [
        {
          value: 1,
          name: "开始前15分钟",
        },
        {
          value: 2,
          name: "开始前20分钟",
        },
        {
          value: 3,
          name: "开始前30分钟",
        },
      ],
      checkDurationOption: [
        {
          value: 1,
          name: "开始前15分钟",
        },
        {
          value: 2,
          name: "开始前20分钟",
        },
        {
          value: 3,
          name: "开始前30分钟",
        },
      ],
      forms: {
        //会议主题
        meetingtTitle: "",
        //会议室
        meetingLocationId: "",
        //开始时间
        meetingStateTime: "",
        //会议时长
        meetingDuration: 1,
        //会议组
        className: "",
        //邀请人
        userIds: "",
        //会议提醒
        meetingReminder: 1,
        //签到时间
        meetingCheckDuration: 1,
        //备注
        remark: "",
        //会议结束时间
        meetingEndTime: "",
        //会议提醒时间
        reminderTime: "",
        //会议签到开始时间
        meetingSignState: "",
      },
      loadingUser: false,
      restaurants: [],
    };
  },
  props: ["onCancel", "newItem", "actions", "ids"],
  created() {
    if (this.actions == "edit") {
      this.id = this.ids
      this.searchEdit()
    }
    this.restaurants = $utils.data.get("restaurants", "") || []
    console.log(this.restaurants);

    this.forms.meetingStateTime = dayjs().minute() < 15
      ? dayjs().minute(15).format("YYYY-MM-DD HH:mm")
      : dayjs().minute() < 30
        ? dayjs().minute(30).format("YYYY-MM-DD HH:mm")
        : dayjs().minute() < 45
          ? dayjs().minute(45).format("YYYY-MM-DD HH:mm")
          : dayjs().minute(60).format("YYYY-MM-DD HH:mm")
    if (this.newItem) {
      this.timeCreated();
    } else {
      this.handleChange(1)
    }
    this.meetingClass();
    this.meetingroom();
    this.loaduserData();
    this.handleChange2(1)
    this.handleChange3(1)

  },

  methods: {
    onClear(item) {
      let index = this.restaurants.findIndex((items => items === item))
      let arr = this.restaurants
      arr.splice(index, 1)
      this.restaurants = arr
      $utils.data.set("restaurants", "", this.restaurants)
    },
    handleSelect(item) {
      console.log(item);
      this.forms.meetingtTitle = item
    },
    querySearch(queryString, cb) {
      console.log(queryString, cb);

      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      console.log(results);

      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    searchKeyword(e) {
      pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
      if (e !== '') {
        let q = {};
        $utils.api.load("/admin/system/user/listAll", q).then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.nickName;
              dropList.push(xx);
            }
            let pinyinStr = pinyin.getCamelChars(e)
            let list = []
            if (e === pinyinStr) {
              for (let i = 0; i < dropList.length; i++) {
                let upPinYin = ""
                let fullPinYin = ""
                if (dropList[i].name) {
                  upPinYin = pinyin.getCamelChars(dropList[i].name);
                  fullPinYin = pinyin.getFullChars(dropList[i].name);
                }
                if (fullPinYin.toUpperCase().includes(pinyinStr.toUpperCase())
                  || upPinYin.toUpperCase().includes(pinyinStr.toUpperCase())) {
                  list.push(dropList[i])
                }
              }
            } else {
              for (let i = 0; i < dropList.length; i++) {
                if (dropList[i].name) {
                  if (dropList[i].name.includes(e)) {
                    list.push(dropList[i])
                  }
                }
              }
            }
            this.userList = list
          }
        });
      } else {
        this.loaduserData()
      }
    },
    async searchEdit() {
      let res = await $utils.api.load(`/admin/system/meeting/${this.id}`)
      if (res.code == 200) {
        let data = res.data
        let q = {
          meetingtTitle: data.meetingtTitle,
          meetingLocationId: data.meetingLocationId,
          meetingStateTime: data.meetingStateTime,
          meetingDuration: Number(data.meetingDuration),
          userIds: data.sysUserList.map((obj) => obj.userId),
          meetingReminder: Number(data.meetingReminder),
          meetingCheckDuration: Number(data.meetingCheckDuration),
          remark: data.remark,
          meetingSignState: data.meetingSignState,
          reminderTime: data.reminderTime,
          meetingEndTime: data.meetingEndTime,
          meetingId: this.id
        }
        this.forms = q
      }

    },
    timeCreated() {
      let state = this.newItem.activeIndexDay + " " + this.newItem.newTime.split("-")[0];
      let end = this.newItem.activeIndexDay + this.newItem.newTime.split("-")[1];
      this.forms.meetingStateTime = state;
      this.forms.meetingLocationId = this.newItem.meetingListItem.id;
      let stateH = Number(this.newItem.newTime.split("-")[0].split(":")[0]) * 100;
      let stateM = Number(this.newItem.newTime.split("-")[0].split(":")[1]);
      let endH = Number(this.newItem.newTime.split("-")[1].split(":")[0]) * 100;
      let endM = Number(this.newItem.newTime.split("-")[1].split(":")[1]);
      let stateNum = stateH + stateM;
      let endNum = endH + endM;
      let timeDiff = endNum - stateNum + "";
      let m = Number(timeDiff.slice(timeDiff.length - 2, timeDiff.length));
      let h = Number(timeDiff.slice(0, timeDiff.length - 2));
      let endNumS = endNum + "";
      let stateNumS = stateNum + "";
      let meetingLength = null;
      if (
        m != 0 &&
        endNumS.slice(endNumS.length - 2, endNumS.length) <
        stateNumS.slice(stateNumS.length - 2, stateNumS.length)
      ) {
        m = 60 - (100 - m);
      }
      if (h > 0) {
        meetingLength = h * 60 + m;
      } else {
        meetingLength = m;
      }
      if (meetingLength / 30 > 13) {
        this.forms.meetingDuration = 13;
      } else {
        this.forms.meetingDuration = Math.ceil(meetingLength / 30);
      }
      this.handleChange(this.forms.meetingDuration)
    },
    onCouponAlis(val) {
      let combined = val.join(",").split(",");
      this.forms.userIds = [...new Set(combined.map(Number))];
    },
    getTime(val) {
      this.autoCalculateTimes(val);
    },
    handleChange(e) {
      console.log(e);

      let val = "";
      let arr = this.durationOption;
      arr.map((item) => {
        if (item.value == e) {
          val = item.name;
        }
      });
      let time = this.forms.meetingStateTime;
      if (!time) {
        $utils.toast.success("请选择开始时间");
        return;
      }
      let duration = this.parseDuration(val);
      let formattedTime = this.formatDate(new Date(new Date(time).getTime() + duration));
      this.forms.meetingEndTime = formattedTime;
    },
    handleChange2(e) {
      let val = "";
      let arr = this.reminderOption;
      arr.map((item) => {
        if (item.value == e) {
          val = item.name;
        }
      });
      let time = this.forms.meetingStateTime;
      if (!time) {
        $utils.toast.success("请选择开始时间");
        return;
      }
      let duration = this.parseDuration(val);
      let formattedTime = this.formatDate(new Date(new Date(time).getTime() - duration));
      this.forms.reminderTime = formattedTime;
    },
    handleChange3(e) {
      let val = "";
      let arr = this.checkDurationOption;
      arr.map((item) => {
        if (item.value == e) {
          val = item.name;
        }
      });
      let time = this.forms.meetingStateTime;
      if (!time) {
        $utils.toast.success("请选择开始时间");
        return;
      }
      let duration = this.parseDuration(val);
      let formattedTime = this.formatDate(new Date(new Date(time).getTime() - duration));
      this.forms.meetingSignState = formattedTime;
    },
    autoCalculateTimes(time) {
      // 设置默认的时长和提醒
      let defaultDuration = "30分钟"; // 会议时长
      const defaultReminder = "15分钟"; // 会议提醒和签到时间
      let arrD = [];
      if (this.newItem) {
        this.items.forEach((item) => {
          if (item.name == "meetingDuration") {
            arrD = item.dropList;
          }
        });
        arrD.forEach((item) => {
          if (item.value == this.forms.meetingDuration) {
            defaultDuration = item.name;
          }
        });
      }
      // 计算会议时长
      const durationMilliseconds = this.parseDuration(defaultDuration);
      const endTime = new Date(new Date(time).getTime() + durationMilliseconds);
      this.forms.meetingEndTime = this.formatDate(endTime); // 计算得到的会议结束时间
      // 计算会议提醒
      const reminderMilliseconds = this.parseDuration(defaultReminder);
      const reminderTime = new Date(new Date(time).getTime() - reminderMilliseconds);
      this.forms.reminderTime = this.formatDate(reminderTime); // 计算得到的会议提醒时间
      // 计算签到时间
      const signInTime = new Date(new Date(time).getTime() - reminderMilliseconds); // 签到时间与会议提醒相同
      this.forms.meetingSignState = this.formatDate(signInTime); // 计算得到的签到时间
    },
    // 时间格式化函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    parseDuration(duration) {
      let milliseconds = 0;
      const hoursPattern = /(\d+(\.\d+)?)(小时)/; // 允许小数
      const minutesPattern = /(\d+(\.\d+)?)(分钟)/; // 允许小数
      const hoursMatch = hoursPattern.exec(duration);
      const minutesMatch = minutesPattern.exec(duration);
      if (hoursMatch) {
        milliseconds += parseFloat(hoursMatch[1]) * 60 * 60 * 1000; // 转换为毫秒
      }
      if (minutesMatch) {
        milliseconds += parseFloat(minutesMatch[1]) * 60 * 1000; // 转换为毫秒
      }
      return milliseconds;
    },
    async meetingroom(e) {
      let d = {
        buildingId: e,
      };
      let res = await $utils.api.load("/admin/system/meeting/room/list", d, "get");
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          let text = element.liableState == 1 ? "(需要审核)" : "";
          xx.value = element.id;
          xx.name = element.meetingName + text;
          dropList.push(xx);
        }
        this.meetingLocationList = dropList
      }
    },
    handleSubmit() {
      let q = this.forms;
      let restaurantsList = this.restaurants
      console.log(restaurantsList);

      if (!restaurantsList.includes(q.meetingtTitle)) {
        restaurantsList.push(q.meetingtTitle)

        $utils.data.set("restaurants", "", restaurantsList)
      }
      console.log(q);

      if (!q.meetingtTitle) {
        $utils.toast.error("请填写会议主题");
        return
      }
      if (!q.meetingLocationId) {
        $utils.toast.error("请选择会议室");
        return
      }
      if (!q.userIds || q.userIds == []) {
        $utils.toast.error("请选择会议组或邀请人");
        return
      }
      q.meetingSignEnd = q.meetingStateTime;

      $utils.api
        .load(`/admin/system/meeting`, q, this.actions == "edit" ? "PUT" : "POST")
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success("保存成功");
            this.$emit("onCancel");
            $utils.url.go(0);
          } else {
            this.$Spin.hide();
          }
        })
        .catch((e) => {
          this.sloading = false;
          this.$Spin.hide();
          $utils.toast.error("保存异常" + e.message);
        });
    },
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/user/listAll", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          this.userList = dropList
        }
      });
    },
    async meetingClass() {
      let d = {};
      let res = await $utils.api.load("/admin/system/meetingClass/seelectList", d, "get");
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.userIdClass;
          xx.name = element.className;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        this.classList = dropList
      }
    },
  },
};
</script>
<style lang="less" scoped>
.form_box {
  .inputWith {
    width: 400px;
  }

  .inputWithTime {
    width: 200px;
  }

  .form_top,
  .form_bottom {
    display: flex;
  }

  .form_top {
    margin-bottom: 40px;

    .facilityType_class {
      padding-left: 100px;
      color: red;
      cursor: pointer;
    }

    .center-02 {
      width: 300px;
      border-radius: 10px;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 1px 2px 5px #8c939d;
      margin-left: 10px;
    }
  }

  .form_top_left,
  .form_bottom_left {
    width: 150px;
  }

  .form_top_left_text,
  .form_bottom_left_text {
    height: 40px;
    line-height: 40px;
    margin: 0 40px;
  }

  .form_bottom {
    margin-bottom: 20px;
  }

  .form_btn {
    margin-left: 150px;
  }
}
</style>
